import * as actionTypes from "../actions/actionTypes";

const initialState = {};

const pagingReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_PAGING:
            return { ...state, [action.pagingKey]: action.list };
        case actionTypes.CLEAR_PAGING: {
            const nextState = { ...state };
            delete nextState[action.pagingKey];
            return nextState;
        }
        default:
            return state;
    }
};

export default pagingReducer;
